import React from 'react'
import "./Transform.css"
import img1 from "../Images/transform1.png"
import img2 from "../Images/transform2.png"
const Transform = () => {
    return (
        <div id='transformm'>
            <div className="section">
                <div className="container">
                    <div className="transform-left">
                        <div className="transform-img">
                            <img src={img1} alt="transform-img" className="innerImage" />
                        </div>
                        <div className="transform-img secondtransformImg">
                            <img src={img2} alt="transform-img" className="innerImage" />
                        </div>
                    </div>
                    <div className="transform-right">
                        <div className="transform-title">
                            <h1 className="heading">Transform Your Ideas into High-Performing Digital Platforms</h1>
                        <p className='para'>
                        From sleek websites to powerful web applications —Bastionex is a top Web Development Company 
                        </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Transform